const mutations = {
  SET_LOADING(state, value) {
    state.isLoading = value
  },
  SET_INITIALIZED(state, value) {
    state.isInitialized = value
  },
  SET_LOCALE(state, value) {
    state.locale = value
  },
  SET_API_VERSION (state, value) {
    state.apiVersion = value
  },
  SET_LAST_PATH(state, value) {
    state.lastPath = value
  }
}

export default mutations
